import { setdefault } from "../util/util";
export class StateError extends Error {
    mAction;
    constructor(action, message) {
        super(message);
        this.name = this.constructor.name;
        this.mAction = action;
    }
}
const sanityChecks = {};
export function reduxSanity(callback) {
    return (store) => (next) => (action) => {
        let invalid = false;
        (sanityChecks[action.type] || []).forEach((check) => {
            const res = check(store.getState(), action);
            if (res === false) {
                invalid = true;
            }
            else if (res !== undefined) {
                callback(new StateError(action, res));
                invalid = true;
            }
        });
        if (invalid) {
            return action;
        }
        return next(action);
    };
}
export function registerSanityCheck(type, check) {
    setdefault(sanityChecks, type, []).push(check);
}
